//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Verify from '../../utils/verify'
import qs from 'qs'
import types from '../../store/mutation-types'

export default {
  name: 'm-form',
  mounted () {
    document.title = '填写投保信息'
  },
  data () {
    return {
      holderIDNumber: '',
      currentOrder: [],
      currentOrderDetail: [],
      orderList: [],
      qzLimit: '',
      qzPremium: '',
      qzPremiumOK: false,
      agreeTerms: true,
      showLogin: false,
      timer: null
    }
  },
  computed: {
    orderPlaceholder () {
      return '您有' + this.orderList.length + '个保单可升级'
    },
    qzPremium2 () {
      if (!this.qzPremium) return this.$store.state.config.minPremium
      this.qzPremiumOK = true
      return this.qzPremium
    },
    agreement () {
      if (this.$store.state.config.policy && this.$store.state.config.policy.agreement) {
        return this.$store.state.config.policy.agreement
      }
    }
  },
  methods: {
    getOrders () {
      // 校验合法性
      if (this.holderIDNumber === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请填写身份证号',
          position: 'top',
          width: '20em'
        })
        return false
      }
      // 判断是否是合法的一代身份证或二代身份证
      if (!Verify.verifyIDNumber(this.holderIDNumber)) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请填写正确的身份证号',
          position: 'top',
          width: '20em'
        })
        return false
      }
      this.$http.get('/api/mild/getPolicyListByIdCard?idCard=' + this.holderIDNumber).then(response => {
        // 登录
        if (response.data.code === 400) {
          this.showLogin = true
          return false
        }
        if (response.data.result === 'success') {
          this.orderList = []
          response.data.data.forEach((ele) => {
            this.orderList.push({name: ele.supplierInsurancePolicyCode + '(被保人: ' + ele.insured + ')', value: ele.orderCode + '&' + ele.supplierInsurancePolicyCode})
          })
          this.currentOrder = []
          this.currentOrderDetail = []
          if (this.orderList.length === 0) {
            this.$vux.toast.show({
              type: 'text',
              text: '客官，您没有可以升级的保单哦，请先购买吧~',
              position: 'top',
              width: '20em',
              time: 4000
            })
            setTimeout(() => {
              window.location.href = window.location.protocol + '//' + window.location.host + '/illness/insurePolicy/' + this.$store.state.app.innerCode + '/' + (window.location.hostname === 'm.wkbins.com' ? '149614236499831794' : '149559395942738681') + '?requireJsApi=true&bomb=1'
            }, 4000)
          }
        }
      })
    },
    toUpper () {
      this.holderIDNumber = this.holderIDNumber.toUpperCase()
    },
    beforeShow () {
      if (this.orderList.length === 0) return false
    },
    formatOrderDisplay (value) {
      return value[0].split('&')[1]
    },
    onChangeOrder () {
      if (!this.currentOrder[0]) return
      // 发送ajax请求
      this.$http.get('/api/mild/getPolicyInfoByOrderCode?orderCode=' + this.currentOrder[0].split('&')[0]).then(response => {
        this.currentOrderDetail = []
        if (response.data.result !== 'success') return
        this.qzLimit = response.data.data.mildCoverage + '万'
        this.qzPremium = response.data.data.mildPremium / 100
        Array.prototype.push.apply(this.currentOrderDetail, [
          {
            'name': '投保人',
            'value': response.data.data.underwritingInfo.policyHolder.holderName
          },
          {
            'name': '身份证号',
            'value': response.data.data.underwritingInfo.policyHolder.holderIdNumber
          },
          {
            'name': '被保险人',
            'value': response.data.data.underwritingInfo.policyInsured.insuredName
          },
          {
            'name': '身份证号',
            'value': response.data.data.underwritingInfo.policyInsured.insuredIdNumber
          },
          {
            'name': '重疾额度',
            'value': response.data.data.underwritingInfo.coverageMultiples / 10 + '万'
          },
          {
            'name': '交费期间',
            'value': response.data.data.underwritingInfo.insurePayWay + '年'
          },
          {
            'name': '保险期间',
            'value': '终身'
          },
          {
            'name': '交费方式',
            'value': '年交'
          },
          {
            'name': '重疾保费',
            'value': response.data.data.underwritingInfo.premium / 100 + '元'
          },
          {
            'name': '受益人',
            'value': '法定'
          }
        ])
      })
    },
    submitOrder () {
      if (!this.currentOrder[0]) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请选择保单',
          position: 'top',
          width: '20em'
        })
        return
      }
      if (!this.agreeTerms) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请您认真阅读理解并同意相关内容后再试',
          position: 'top',
          width: '20em'
        })
        return
      }
      this.$vux.loading.show({
        text: '正在提交'
      })
      this.$http.post('/api/mild/goInsurePolicy?', qs.stringify({supplierInsurancePolicyCode: this.currentOrder[0].split('&')[1], innerCode: this.$store.state.app.innerCode, orderCode: this.currentOrder[0].split('&')[0]})).then(response => {
        if (!response.data.unionOrderCode) {
          this.$vux.loading.hide()
          this.$vux.toast.show({
            type: 'text',
            text: '客官，升级失败',
            position: 'top',
            width: '20em'
          })
          return
        }
        this.$store.commit(types.UPDATE_ORDER_UNIONCODE, response.data.unionOrderCode)
        this.timer = setInterval(() => {
          this.submit()
        }, 3000)
        this.submit()
      })
    },
    submit () {
      let judgeURL = '/api/illness/judgeInsurance/' + this.$store.state.order.unionCode
      judgeURL += ('?innerCode=' + this.$store.state.app.innerCode)
      this.$http.get(judgeURL).then(response => {
        if (response.data[0].undwrtStatus === 2) {
          this.$vux.loading.hide()
          this.$vux.alert.show({
            title: '核保失败',
            content: response.data[0].undwrtMsg || '核保超时',
            buttonText: '知道了'
          })
          clearInterval(this.timer)
        }
        if (response.data[0].undwrtStatus !== 0 && response.data[0].undwrtStatus !== 2) {
          this.$vux.loading.hide()
          clearInterval(this.timer)
          this.$router.push({name: 'Pay', params: {productCode: this.$store.state.app.productCode, innerCode: this.$store.state.app.innerCode, unionCode: this.$store.state.order.unionCode}, query: this.$route.query})
        }
      })
    },
    closeLogin () {
      this.showLogin = false
      // this.getOrders()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/customs/GuoHuaQingZhengForm.vue